import { useEffect, useState } from 'react';

import { Badge, Label } from '@@/ui/primitives';
import { Editor } from '@monaco-editor/react';

interface ObjectInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
  height?: string;
}

export function ObjectInput({ value, onChange, disabled = false, label, height = '200px' }: ObjectInputProps) {
  const [textValue, setTextValue] = useState(() => {
    return typeof value === 'object' && value !== null ? JSON.stringify(value, null, 2) : value || '';
  });

  useEffect(() => {
    if (typeof value === 'object' && value !== null) {
      setTextValue(JSON.stringify(value, null, 2));
    } else if (typeof value === 'string') {
      setTextValue(value);
    }
  }, [value]);

  const handleEditorChange = (value: string | undefined) => {
    const newValue = value || '';
    setTextValue(newValue);

    try {
      const parsed = JSON.parse(newValue);
      onChange(parsed);
    } catch {
      onChange(newValue);
    }
  };

  return (
    <div className='space-y-2'>
      <div className='flex items-center gap-2'>
        {label && <Label className='text-neutral-800 text-sm font-medium'>{label}</Label>}
        <Badge variant='outline' className='text-slate-800 border-slate-400 text-xs!'>
          JSON
        </Badge>
      </div>
      <Editor
        className='rounded-lg overflow-hidden border shadow-xs'
        height={height}
        defaultLanguage='json'
        value={textValue}
        onChange={handleEditorChange}
        options={{
          readOnly: disabled,
          minimap: { enabled: false },
          scrollBeyondLastLine: false,
          fontSize: 13,
          lineNumbers: 'on',
          wordWrap: 'on',
          wrappingIndent: 'same'
        }}
      />
    </div>
  );
}
